import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Alert, Button, Form, Modal, Pagination } from "react-bootstrap";
import Select from 'react-select';
import SuppliersTableRow from "./SuppliersTableRow";
import Loader from "../../../loader/Loader";
import { Helmet } from "react-helmet";
import AxiosController from "../../../authentication/AxiosController";
const get_warehouses = (
  slug,
  lang,
  token,
  handleWarehouses,
  userId,
  page,
  setLoading
) => {
  AxiosController.get(
    `api/${slug}/${lang}/fulfillments/govs/${userId}/${page}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      handleWarehouses(res.data);
      setLoading(false);
    })
    .catch((e) => {
      setLoading(false);
    });
};
const get_warehouses2 = (
  slug,
  lang,
  token,
  handleWarehouses,
  userId,
  setLoading
) => {
  AxiosController.get(`api/${slug}/${lang}/couriers/get-courier/${userId}/`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      handleWarehouses(res.data);
      setLoading(false);
    })
    .catch((e) => {
      setLoading(false);
    });
};

const get_shippingcosts = (
  slug,
  lang,
  token,
  shippingcostsHandler,
  setLoading
) => {
  AxiosController.get(`api/${slug}/${lang}/get-shippingcost/`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      shippingcostsHandler(res.data);
      setLoading(false);
    })
    .catch((e) => { });
};

const createWarehouse = (
  slug,
  lang,
  token,
  userId,
  govIds,
  cost,
  handling,
  extra_handling,
  setLoading,
  setShow,
  handleSuppliers
) => {
  setLoading(true);
  AxiosController.post(
    `api/${slug}/${lang}/fulfillments/gov/new/`,
    { user_id: userId, gov_ids: govIds, price: cost },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      get_warehouses(
        slug,
        lang,
        token,
        handleSuppliers,
        userId,
        1,
        setLoading
      );
      setShow(false);
    })
    .catch((e) => {
      setLoading(false);
    });
};

const ShippingSellerFulfillment = () => {
  const { slug, lang, userId } = useParams();
  const location = useLocation();
  const Navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const token = localStorage.getItem("token");
  const [_] = useTranslation("global");
  const [suppliers, handleSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cost, setCost] = useState(0);
  const [handling, setHandling] = useState(0);
  const [extraHandling, setExtraHandling] = useState(0);
  const [show, setShow] = useState(false);
  const [shippingCosts, setShippingCosts] = useState([]);
  const [courier, setCourier] = useState({});
  const [selectedGovIds, setSelectedGovIds] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [page, handlePage] = useState(urlParams.get("page") || 1);

  const handleClose = () => {
    setShow(false);
    setSelectedGovIds([]);
    setIsEditing(false);
  };

  const handleShow = () => {
    setCost(0);
    setHandling(0);
    setExtraHandling(0);
    setSelectedGovIds([]);
    setIsEditing(false);
    setShow(true);
  };

  const handleEdit = (govId, currentCost) => {
    setCost(currentCost);
    setSelectedGovIds([govId]);
    setIsEditing(true);
    setShow(true);
  };

  const handleGovSelect = (selectedOption) => {
    if (isEditing) {
      // Single select for editing
      setSelectedGovIds(selectedOption ? [selectedOption.value] : []);
    } else {
      // Multi select for new entries
      if (selectedOption && selectedOption.some(option => option.value === 'all')) {
        const allOptions = shippingCosts.map(gov => ({
          value: gov.id,
          label: `${gov.arabic_name} - ${gov.cost}`
        }));
        setSelectedGovIds(allOptions.map(option => option.value));
      } else {
        setSelectedGovIds(selectedOption ? selectedOption.map(option => option.value) : []);
      }
    }
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '40px',
      height: 'auto'
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999
    })
  };

  const options = isEditing 
    ? shippingCosts.map(gov => ({
        value: gov.id,
        label: `${gov.arabic_name} - ${gov.cost}`
      }))
    : [
        { value: 'all', label: _("panel.selectAll") },
        ...shippingCosts.map(gov => ({
          value: gov.id,
          label: `${gov.arabic_name} - ${gov.cost}`
        }))
      ];

  const getSelectedOptions = () => {
    if (!Array.isArray(selectedGovIds)) {
      return [];
    }
    if (isEditing) {
      return shippingCosts
        .filter(gov => selectedGovIds.includes(gov.id))
        .map(gov => ({
          value: gov.id,
          label: `${gov.arabic_name} - ${gov.cost}`
        }));
    }
    if (selectedGovIds.length === shippingCosts.length) {
      return [{ value: 'all', label: _("panel.selectAll") }];
    }
    return shippingCosts
      .filter(gov => selectedGovIds.includes(gov.id))
      .map(gov => ({
        value: gov.id,
        label: `${gov.arabic_name} - ${gov.cost}`
      }));
  };

  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const changeParam = (param, value) => {
    urlParams.set(param, value);
    Navigate(`?${urlParams.toString()}`);
  };

  useEffect(() => {
    setLoading(true);
    const nextPage = parseInt(urlParams.get("page"), 10) || 1;
    handlePage(nextPage);
    get_shippingcosts(slug, lang, token, setShippingCosts, setLoading);
    get_warehouses(
      slug,
      lang,
      token,
      handleSuppliers,
      userId,
      nextPage,
      setLoading
    );
    get_warehouses2(slug, lang, token, setCourier, userId, setLoading);
  }, [slug, lang, location.search, userId]);

  return (
    <div
      className="position-relative tables-container"
      style={{ minHeight: "100px", width: "100%" }}
    >
      <Helmet>
        <title>{_("panel.fulfillmentShippingPricing")}</title>
      </Helmet>
      <Button
        className="mt-4"
        variant="primary"
        onClick={handleShow}
        style={{ background: "#59C6C9", color: "white", border: "none" }}
      >
        {_("panel.add")}
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-0" dir={box_head_dir}>
          <Modal.Title className="flex-grow-1">
            {isEditing ? _("panel.edit") : _("panel.add")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body dir={box_head_dir}>
          <div className="mb-3">
            <label className="form-label">{_("home.province")}</label>
            <Select
              isMulti={!isEditing}
              name="governments"
              options={options}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={handleGovSelect}
              styles={customStyles}
              placeholder={_("panel.selectGovernments")}
              value={getSelectedOptions()}
            />
          </div>
          {label_input(_("panel.cost"), cost, setCost)}
        </Modal.Body>
        <Modal.Footer className="border-0" dir={box_head_dir}>
          <Button
            variant="primary"
            onClick={() => {
              createWarehouse(
                slug,
                lang,
                token,
                userId,
                selectedGovIds,
                cost,
                handling,
                extraHandling,
                setLoading,
                setShow,
                handleSuppliers
              );
            }}
            disabled={selectedGovIds.length === 0}
          >
            {isEditing ? _("panel.update") : _("panel.save")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Loader active={loading} />
      <div
        className="tables-container d-flex flex-column px-2"
        style={{ position: "relative", flexGrow: 3 }}
      >
        <div
          className={`header d-flex ${lang === "en" ? "flex-row" : "flex-row"
            } gap-3 align-items-center justify-content-between`}
        >
          <h3 className="fs-1" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.fulfillmentShippingPricing")}{" "}
            <span style={{ color: "rgb(243, 168, 55)" }}>{courier?.name}</span>
          </h3>
        </div>
        <div className="footer d-flex flex-column flex-grow-1">
          {suppliers.data ? (
            <SuppliersTableRow
              payments_list={suppliers.data}
              setLoading={setLoading}
              setShow={setShow}
              setCost={setCost}
              setGovId={setSelectedGovIds}
              setHandling={setHandling}
              setExtraHandling={setExtraHandling}
            />
          ) : (
            ""
          )}
          {suppliers.data ? (
            <Pagination
              className="m-auto flex-wrap"
              dir={lang === "ar" ? "ltr" : ""}
            >
              <Pagination.First onClick={() => changeParam("page", 1)} />
              <Pagination.Prev
                onClick={() =>
                  page - 1 > 0 ? changeParam("page", page - 1) : 1
                }
              />
              {suppliers["links"].map((element, index, arr) => {
                if (index == 0 || arr.length - 1 == index) {
                  return "";
                } else {
                  return (
                    <Pagination.Item
                      active={element["active"] ? true : false}
                      onClick={(e) =>
                        element["label"] != "..."
                          ? changeParam("page", parseInt(element["label"]))
                          : ""
                      }
                    >
                      {element["label"]}
                    </Pagination.Item>
                  );
                }
              })}
              <Pagination.Next onClick={() => changeParam("page", page + 1)} />
              <Pagination.Last
                onClick={() => changeParam("page", suppliers["last_page"])}
              />
            </Pagination>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
const label_input = (label, newWarehouseName, handleNewWarehouseName) => {
  return (
    <div className="mb-3">
      <label htmlFor="exampleInputEmail1" className="form-label">
        {label}
      </label>
      <input
        type="text"
        className="form-control py-2 egp"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        value={newWarehouseName}
        onInput={(e) => handleNewWarehouseName(e.target.value)}
      />
    </div>
  );
};
export default ShippingSellerFulfillment;
